import Dexie from 'dexie'

let Db = new Dexie("clave-verde-db");

Db.version(1).stores({
	configs: 'key,value'
})

export default Db
